import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import * as _ from 'lodash-es';
import { InputDialog } from '../input-dialog/input-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';


export interface InputDialogOptions {
    label: string;
    defaultValue: any;
    controlName: string;
    placeholder: string;
}

@Component({
    selector: 'app-multi-input-dialog',
    templateUrl: './multi-input-dialog.component.html',
    styleUrls: ['./multi-input-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class MultiInputDialog implements OnInit {
    protected fb = inject(FormBuilder);
    protected dialogRef = inject<MatDialogRef<InputDialog>>(MatDialogRef);
    config = inject<{
    inputs: InputDialogOptions[];
    valid: string;
    title: string;
}>(MAT_DIALOG_DATA);


    get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }

    form: FormGroup;
    title: string = '';
    label: string = '';
    valid: string;
    defaultValue: string;
    placeholder: string;

    get isValid(): boolean { return this.form.valid; }

    constructor() {
        const fb = this.fb;
        const config = this.config;




        this.form = fb.group({});
        this.title = config.title || '';
        this.valid = config.valid || 'YES';


        config.inputs.forEach((option, index) => {
            this.label = option.label || '';
            this.placeholder = option.placeholder || '';
            this.form.addControl(option.controlName, new FormControl(option.defaultValue || '', [Validators.required]));
        });
        

    }

    ngOnInit() { }

    submit(): void {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }

    close(): void {
        this.dialogRef.close();
    }
}
